import { Language } from '../context/LanguageContext';

interface SectionTitle {
    firstLine: string;
    secondLine: string;
}

interface SectionContent {
    description: string[];
}

export interface TourmalinesTranslations {
    firstLine: string;
    secondLine: string;
    section1: SectionTitle & SectionContent;
    section2: SectionTitle & SectionContent;
    section3: SectionContent;
    section4: SectionContent;
    section5: SectionContent;
    section6: SectionContent;
    section7: SectionContent;
    section8: SectionContent;
    section9: SectionContent;
    section10: SectionContent;
    section11: SectionContent;
    section12: SectionContent;
    section13: SectionContent;
    section14: SectionContent;
    section15: SectionContent;
    section16: SectionContent;
    section17: SectionContent;
    section18: SectionContent;
    section19: SectionContent;
    section20: SectionContent;
    section21: SectionContent;
    section22: SectionContent;
    section23: SectionContent;
    section24: SectionContent;
    section25: SectionContent;
    section26: SectionContent;
    section27: SectionContent;

}

export const tourmalinesTranslations: Record<string, TourmalinesTranslations> = {
    en: {
        firstLine: "TOURMALINES",
        secondLine: "the COMPASS",
        section1: {
            firstLine: "THE COMPASS of",
            secondLine: "the old Vikings",
            description: [
                "One thousand years ago, nearly 500 years before the compass was invented, the old Vikings had a navigation instrument which was nearly as effective - the tourmaline.",
                "Tourmaline is the only natural substance which is a polarisation-filter (except quinine-crystals, which were too small). Light gets polarized when it is reflected at a 90° angle. If you are under a thick layer of clouds, with a polarisation-filter you can still determine from which direction you receive polarized light. Having that information, you know the position of the sun, which stands at a 90° angle.",
                "Tourmaline was the compass of the Vikings, which was one of the reasons why they dominated the Northern Atlantic for more than 500 years."
            ]
        },
        section2: {
            firstLine: "THE SYMBOLIC MEANING",
            secondLine: "of the Tourmaline Compass",
            description: [
                "In a critical situation, when the usual orientation marks disappeared, and along with them the base for a calculated navigation, you needed an alternative approach to find the right way. When you can't see the light anymore, the capacity to keep track and take the right steps is of extreme importance.",
                "The tourmaline, a compass based on light, not on the magnetic field of the earth, stands as a symbol for our intuition, for the capacity to listen to our inner voice, when problems and danger surround us.",
                "Intuition can be trained. It is the direct link to knowledge. Thoughts do not create knowledge, they only present it, sometimes well, sometimes not. Intuition and mental reasoning are two different ways to reach knowledge. To train intuition means not to rely on our persuasive mentality but switch off thinking, and follow the inner feeling of what is good and what not."
            ]
        },
        section3: {
            description: [
                "One of the biggest achievements of the research-department of Niveau élevé is the development of the technology to polish tourmalines in such a way that they vibrate with a particular frequency.",
                "Especially interesting is the frequency 888 KHz, since 888 is a very popular number in whole of Asia.."
            ]
        },
        section4: {
            description: [
                "There are in principle two crystals which are piezoelectric and which produce a reference-frequency (according to their geometry) which is stable enough to drive a watch: quartz and tourmaline.",
                "Tourmaline is much stronger in its piezoelectricity than quartz. Tourmaline is a permanent \"dipole\", while quartz is only a temporary dipole. Also the tourmaline piezoelectric polarisation of quartz vanishes above a temperature of 500°C, while it stays with tourmaline. So for piezoelectric pressure-meters of aircraft-turbines, where the measurement has to be taken at around 2000°C, only tourmalines are used. So in principle tourmalines are the better frequency stones, compared to quartz."
            ]
        },
        section5: {
            description: [
                "Tourmalines are well known and very popular as gemstones."
            ]
        },
        section6: {
            description: [
                "And even those big tourmalines could drive a watch!"
            ]
        },
        section7: {
            description: [
                "Although the big tourmalines have a very strong frequency, and would drive the watch very well, they are of course to big for a wristwatch."
            ]
        },
        section8: {
            description: [
                "For the watches we have to use rather small tourmalines"
            ]
        },
        section9: {
            description: [
                "The tourmalines for watches are easier to polish. Here we can polish regular cubicles which have a clear geometry and are vibrating strongly."
            ]
        },
        section10: {
            description: [
                "For jewellery we have to take shapes which have a \"flash\", which reflect the light and which are sparkling. With those shapes the polishing is more complicated.",
                "Niveau élevé has developed the \"lucky star\", which is a hexagonal cut, where the geometry is also producing a very stable and strong frequency and the stone has a strong sparkling. But to develop such a cut takes a long time of research, where the reflection of light inside the stone and the particular axes of piezoelectricity have to be combined to give good results both optically as also electronically."
            ]
        },
        section11: {
            description: [
                "During the process of polishing, we have to check again and again the frequency of the stone, until we finally reach the desired frequency of 888 KHz. It may take up to 30 times that one has to set the stone back on the polishing wheel, until we have really reached with precision the right frequency."
            ]
        },
        section12: {
            description: [
                "But just polishing the right frequency is not everything. We have to see in the oscilloscope, that the frequency is \"clean\"."
            ]
        },
        section13: {
            description: [
                "Not every tourmaline is suitable. The stone may have \"side-frequencies\" or \"noise\". In such a case we cannot use the stone, because the frequency may jump from one value to another."
            ]
        },
        section14: {
            description: [
                "With a frequency-generator we are \"sweeping\" the range around the 888 KHz to see how the tourmaline performs."
            ]
        },
        section15: {
            description: [
                "Also important: the stone should not have a double or triple-frequency, then also the frequency may switch from one value to another."
            ]
        },
        section16: {
            description: [
                "Then the frequency should not be too low and \"shallow\", but high and sharp!"
            ]
        },
        section17: {
            description: [
                "In the end, after many tests, we get a good tourmaline with a clear and strong frequency of 888 KHz and we get the stone certified, including the frequency, by IGI ." 
            ]
        },
        section18: {
            description: [
                "The tourmaline may be placed in the tourmaline-watch in such a way that one can see it, or it can be placed in a way that one cannot see it from outside the watch."
            ]
        },
        section19: {
            description: [
                "The reason why in all electronic watches quartzes are used and not tourmalines is very simple:",
                "a) Quartz can be manufactured synthetically. Tourmaline not. A tourmaline always is a natural tourmaline. And that brings a problem with it: Every tourmaline is different. There are no two tourmalines exactly the same, like there are no two human beings exactly the same. So one has to polish each and every tourmaline from the beginning to the end, individually. There can be no machine-automated mass-production with frequency-tourmalines.",
                "b) While a synthetic quartz is extremely cheap, a tourmaline is a gemstone, and gemstones are expensive. So this is why it was till today never tried to use tourmalines for providing the reference-frequency for watches."
            ]
        },
        section20: {
            description: [
                "The polishing of frequency tourmalines and the manufacturing of tourmaline-watches is a high-tech work. It has taken us 5 years to develop the technology and we are still learning every day something new. Till today only the piezoelectric properties of quartz are well researched. In fact, there have been hundreds of scientists working on the quartz frequency technology for more than 100 years. Niveau élevé is the only company world-wide which has taken up to research on tourmalines. We have already obtained several patents on the technology and are the only watch-makers who are capable of producing tourmaline-watch-movements."
            ]
        },
        section21: {
            description: [
                "The tourmaline jewellery is an off-shoot of the tourmaline watch project. It is simpler to polish tourmalines for watches, because they can have a simple geometrical shape. With frequency-tourmalines for jewellery, a lot of studies are required to come to a geometry which is giving a clear and strong frequency and at the same time, which reflects the light in a way that the stone sparkles and is an interesting gem-stone. So only now, after a couple of research in watch-tourmalines, we have also started jewellery-tourmalines with particular frequencies.",
                "The most interesting in tourmaline-frequency stones is the \"Lucky Star\" with the frequency of 888 KHz."
            ]
        },
        section22: {
            description: [
                "The \"Lucky Ring\" with two tourmalines with frequency 888 KHz is available in all tourmaline colours. All the stones are always certified, whereby the International Gemological Institute is checking very strictly the correctness of the frequency, before issuing a certificate. Each certificate has a picture of the stone and the tourmalines have a laser-inscription at the girdle which shows the certificate number."
            ]
        },
        section23: {
            description: [
                "The standard-frequencies which we are polishing are:",
                "555 KHz",
                "696 KHz",
                "777 KHz",
                "888 KHz",
                "999 KHz"
            ]
        },
        section24: {
            description: [
                "All the frequencies from 555 KHz till 999 KHz are in the size of 4,5 mm to 7,0 mm. The bigger tourmalines have lower frequencies, like from 230 KHz to 510 KHz"
            ]
        },
        section25: {
            description: [
                "All the certificates can be checked on the website of IGI",
                "If a client would lose the certificate, he can read the laser-inscription (with a 20 x loupe or with a binocular), and then print out the cert again from the IGI website.",
                "This is how you can check or download your IGI certificate:",
                "Go on the IGI website",
                "Then click on \"Verify Your Report\"",
                "Then type in your \"Summary No.\"",
                "When you type in the number, you first get the Summary. Then you have to click on PDF report,",
                "Then you get the full cert-copy as PDF"
            ]
        },
        section26: {
            description: [
                "The possibilities for jewellery with frequency tourmalines is unlimited.",
                "The snake-ring with a tourmaline at the head, vibrating at the frequency of 888 KHz is a very interesting article."
            ]
        },
        section27: {
            description: [
                "With the bigger tourmalines, the frequencies are much lower, due to the different geometry.",
                "But also with the lower frequencies, from 200 till 390 KHz, there are interesting symbolic frequencies. For example, all prime numbers. A prime number is undividable. It stands for a strong will-power, for a strong determination, for power of implementation.",
                "There are 60 prime numbers which may be used as reference-frequency for our big tourmalines.",
                "In numerology the cross-sum of a number is always regarded as very important. The classical numerology always takes first the cross-sum of a two-digit or three-digit number and looks what message the cross-sum tells us.",
                "So Niveau élevé is using frequencies which have as cross-sum the 8, like 233 KHz (2 + 3 + 3 = 8) or 323 (3 + 2 + 3 = 8) or 314, 332, 215 and so on.",
                "Also frequencies which have a numerical cross-sum of 7 or of 9 are interesting.",
                "Every frequency of a tourmaline has a meaning and is a symbol. And every piece of jewellery with a frequency-tourmaline offers us the chance to change something in our life. When we choose to let a tourmaline enter our life, we should not just hope that the gemstone will do the work and bring about a change. We have to actively make a resolution to improve our old habits and take the gem as a symbol for our own effort to make a progress. Everything can be changed. It is only a question of how much energy we are willing to put up. So let us resolve that we will make a step into a new phase of our life and then let us consequently follow our resolution!"
            ]
        }
    },
    de: {
        firstLine: "TURMALIN",
        secondLine: "der KOMPASS",
        section1: {
            firstLine: "DER KOMPASS der",
            secondLine: "alten Wikinger",
            description: [
                "Vor tausend Jahren, fast 500 Jahre bevor der Kompass erfunden wurde, hatten die alten Wikinger ein Navigationsinstrument, das fast genauso effektiv war - den Turmalin.",
                "Turmalin ist der einzige natürliche Stoff, der Licht polarisiert (abgesehen von Chinin-Kristallen, die zu klein waren). Licht wird polarisiert, wenn es in einem 90°-Winkel reflektiert wird. Wenn man sich unter einer dicken Wolkenschicht befindet, kann man mit einem Polarisationsfilter immer noch bestimmen, aus welcher Richtung man polarisiertes Licht empfängt. Mit dieser Information kennt man die Position der Sonne, die in einem 90°-Winkel steht.",
                "Der Turmalin war der Kompass der Wikinger, was einer der Gründe war, warum sie den Nordatlantik mehr als 500 Jahre lang beherrschten."
            ]
        },
        section2: {
            firstLine: "DIE SYMBOLISCHE BEDEUTUNG",
            secondLine: "des Turmalin-Kompasses",
            description: [
                "In einer kritischen Situation, wenn die üblichen Orientierungsmarken verschwunden sind und damit auch die Grundlage für eine berechnete Navigation, brauchte man einen alternativen Ansatz, um den richtigen Weg zu finden. Wenn man das Licht nicht mehr sehen kann, ist die Fähigkeit, die Übersicht zu behalten und die richtigen Schritte zu unternehmen, von extremer Wichtigkeit.",
                "Der Turmalin, ein Kompass, der auf Licht und nicht auf dem Magnetfeld der Erde basiert, steht als Symbol für unsere Intuition, für die Fähigkeit, auf unsere innere Stimme zu hören, wenn uns Probleme und Gefahren umgeben.",
                "Intuition kann trainiert werden. Sie ist die direkte Verbindung zum Wissen. Gedanken schaffen kein Wissen, sie präsentieren es nur, manchmal gut, manchmal nicht. Intuition und mentales Denken sind zwei verschiedene Wege, um Wissen zu erlangen. Intuition zu trainieren bedeutet, sich nicht auf unsere überzeugende Mentalität zu verlassen, sondern das Denken auszuschalten und dem inneren Gefühl zu folgen, was gut ist und was nicht."
            ]
        },
        section3: { description: ["This is the description for section 3."] },
        section4: { description: ["This is the description for section 4."] },
        section5: { description: ["This is the description for section 5."] },
        section6: { description: ["This is the description for section 6."] },
        section7: { description: ["This is the description for section 7."] },
        section8: { description: ["This is the description for section 8."] },
        section9: { description: ["This is the description for section 9."] },
        section10: { description: ["This is the description for section 10."] },
        section11: { description: ["This is the description for section 11."] },
        section12: { description: ["This is the description for section 12."] },
        section13: { description: ["This is the description for section 13."] },
        section14: { description: ["This is the description for section 14."] },
        section15: { description: ["This is the description for section 15."] },
        section16: { description: ["This is the description for section 16."] },
        section17: { description: ["This is the description for section 17."] },
        section18: { description: ["This is the description for section 18."] },
        section19: { description: ["This is the description for section 19."] },
        section20: { description: ["This is the description for section 20."] },
        section21: { description: ["This is the description for section 21."] },
        section22: { description: ["This is the description for section 22."] },
        section23: { description: ["This is the description for section 23."] },
        section24: { description: ["This is the description for section 24."] },
        section25: { description: ["This is the description for section 25."] },
        section26: { description: ["This is the description for section 26."] },
        section27: { description: ["This is the description for section 27."] }
    },
    fr: {
        firstLine: "TOURMALINES",
        secondLine: "la BOUSSOLE",
        section1: {
            firstLine: "LA BOUSSOLE des",
            secondLine: "anciens Vikings",
            description: [
                "Il y a mille ans, près de 500 ans avant l'invention de la boussole, les anciens Vikings possédaient un instrument de navigation presque aussi efficace - la tourmaline.",
                "La tourmaline est la seule substance naturelle qui soit un filtre de polarisation (à l'exception des cristaux de quinine, qui étaient trop petits). La lumière est polarisée lorsqu'elle est réfléchie à un angle de 90°. Si vous êtes sous une épaisse couche de nuages, avec un filtre de polarisation, vous pouvez toujours déterminer de quelle direction vous recevez la lumière polarisée. Avec cette information, vous connaissez la position du soleil, qui se trouve à un angle de 90°.",
                "La tourmaline était la boussole des Vikings, ce qui était l'une des raisons pour lesquelles ils ont dominé l'Atlantique Nord pendant plus de 500 ans."
            ]
        },
        section2: {
            firstLine: "LA SIGNIFICATION SYMBOLIQUE",
            secondLine: "de la Boussole en Tourmaline",
            description: [
                "Dans une situation critique, lorsque les repères d'orientation habituels ont disparu, et avec eux la base d'une navigation calculée, vous aviez besoin d'une approche alternative pour trouver le bon chemin. Quand vous ne pouvez plus voir la lumière, la capacité à garder le cap et à prendre les bonnes décisions est d'une importance extrême.",
                "La tourmaline, une boussole basée sur la lumière, et non sur le champ magnétique de la terre, est un symbole de notre intuition, de la capacité à écouter notre voix intérieure, lorsque les problèmes et le danger nous entourent.",
                "L'intuition peut être entraînée. C'est le lien direct avec la connaissance. Les pensées ne créent pas la connaissance, elles ne font que la présenter, parfois bien, parfois mal. L'intuition et le raisonnement mental sont deux façons différentes d'atteindre la connaissance. Entraîner l'intuition signifie ne pas se fier à notre mentalité persuasive mais éteindre la pensée, et suivre le sentiment intérieur de ce qui est bon et ce qui ne l'est pas."
            ]
        },
        section3: { description: ["This is the description for section 3."] },
        section4: { description: ["This is the description for section 4."] },
        section5: { description: ["This is the description for section 5."] },
        section6: { description: ["This is the description for section 6."] },
        section7: { description: ["This is the description for section 7."] },
        section8: { description: ["This is the description for section 8."] },
        section9: { description: ["This is the description for section 9."] },
        section10: { description: ["This is the description for section 10."] },
        section11: { description: ["This is the description for section 11."] },
        section12: { description: ["This is the description for section 12."] },
        section13: { description: ["This is the description for section 13."] },
        section14: { description: ["This is the description for section 14."] },
        section15: { description: ["This is the description for section 15."] },
        section16: { description: ["This is the description for section 16."] },
        section17: { description: ["This is the description for section 17."] },
        section18: { description: ["This is the description for section 18."] },
        section19: { description: ["This is the description for section 19."] },
        section20: { description: ["This is the description for section 20."] },
        section21: { description: ["This is the description for section 21."] },
        section22: { description: ["This is the description for section 22."] },
        section23: { description: ["This is the description for section 23."] },
        section24: { description: ["This is the description for section 24."] },
        section25: { description: ["This is the description for section 25."] },
        section26: { description: ["This is the description for section 26."] },
        section27: { description: ["This is the description for section 27."] }
    },
    zh: {
        firstLine: "碧璽",
        secondLine: "指南針",
        section1: {
            firstLine: "古維京人的",
            secondLine: "指南針",
            description: [
                "一千年前，差不多指南針被發明的 500 年前，古維京人就擁有幾乎同樣有效的導航工具：碧璽。",
                "碧璽是唯一具有偏振濾光功能的天然物質（奎寧晶體除外，因為它們太小）。當光線以 90° 角反射時，它會被偏振。如果你身處厚厚的雲層之下，利用偏振濾光鏡，您仍然可以確定從哪個方向接收到偏振光。擁有這些訊息，你就知道太陽的位置，它處於 90° 角的位置。",
                "碧璽是維京人的指南針，這也是他們能稱霸北大西洋超過 500 年的原因之一。"
            ]
        },
        section2: {
            firstLine: "碧璽指南針的",
            secondLine: "象徵意義",
            description: [
                "在危急情況下，當常見的方向標記消失及計算導航的基礎也隨之消失時，你需要替代方法來找到正確道路。當你無法再看到光明時，確保知道並採取正確步驟的能力至關重要。",
                "碧璽是種基於光而不是地球磁場的指南針，它代表一種象徵，對我們的直覺；亦對我們在問題和危險環繞時傾聽內在聲音的能力。",
                "直覺是可以訓練的。它是與知識的直接連結。思想不會創造知識，它們只能呈現知識，有時呈現得很好，有時則不然。直覺和思想推理是獲取知識的兩種不同方式。訓練直覺意味著不要依賴我們的說服式思想方法，而是關閉思考，並遵循內心何謂好壞的感覺。"
            ]
        },
        section3: { description: ["This is the description for section 3."] },
        section4: { description: ["This is the description for section 4."] },
        section5: { description: ["This is the description for section 5."] },
        section6: { description: ["This is the description for section 6."] },
        section7: { description: ["This is the description for section 7."] },
        section8: { description: ["This is the description for section 8."] },
        section9: { description: ["This is the description for section 9."] },
        section10: { description: ["This is the description for section 10."] },
        section11: { description: ["This is the description for section 11."] },
        section12: { description: ["This is the description for section 12."] },
        section13: { description: ["This is the description for section 13."] },
        section14: { description: ["This is the description for section 14."] },
        section15: { description: ["This is the description for section 15."] },
        section16: { description: ["This is the description for section 16."] },
        section17: { description: ["This is the description for section 17."] },
        section18: { description: ["This is the description for section 18."] },
        section19: { description: ["This is the description for section 19."] },
        section20: { description: ["This is the description for section 20."] },
        section21: { description: ["This is the description for section 21."] },
        section22: { description: ["This is the description for section 22."] },
        section23: { description: ["This is the description for section 23."] },
        section24: { description: ["This is the description for section 24."] },
        section25: { description: ["This is the description for section 25."] },
        section26: { description: ["This is the description for section 26."] },
        section27: { description: ["This is the description for section 27."] }
    }
};

export function getTourmalinesTranslations(language: Language): any {
    return tourmalinesTranslations[language] || tourmalinesTranslations.en;
}